// extracted by mini-css-extract-plugin
module.exports = {"GroupMarks":"GroupMarks_GroupMarks__2w9Xu","GroupMark":"GroupMarks_GroupMark__3QRVP","GroupMarkLabel":"GroupMarks_GroupMarkLabel__21SU7"};